import React from 'react';
import PropTypes from 'prop-types';

import { NavigationTabsContainer, NavigationTab, SelectedNavigationTab } from './UAMTabsStyles';
import { destinationInfo } from '../../destructured-front-end-config';
import { composeDestinationQuerystring } from '../../../shared-with-server/destination-utils';

const UAMTabs = ({ activeTab, destPath }) => {
  const FirstTabComponent = activeTab === 1 ? SelectedNavigationTab : NavigationTab;
  const SecondTabComponent = activeTab === 2 ? SelectedNavigationTab : NavigationTab;

  return (
    <NavigationTabsContainer>
      <FirstTabComponent>
        {
          activeTab !== 1
            ? <a href={`/uam/login?${composeDestinationQuerystring(destinationInfo, destPath)}`}>Sign in</a>
            : <span>Sign in</span>
        }
      </FirstTabComponent>
      <SecondTabComponent>
        {
          activeTab !== 2
            ? <a href={`/uam/email?${composeDestinationQuerystring(destinationInfo, destPath)}`}>Create account</a>
            : <span>Create account</span>
        }
      </SecondTabComponent>
    </NavigationTabsContainer>
  );
};

UAMTabs.propTypes = {
  activeTab: PropTypes.number.isRequired,
  destPath: PropTypes.object.isRequired,
};

export default UAMTabs;
